<template>
  <div class="content">
    
    
    <div class="mainContent">
     
      <div class="main">
         <div class="title">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item @click.native="goback">返回</el-breadcrumb-item>
        <el-breadcrumb-item>师资培训</el-breadcrumb-item>
        <el-breadcrumb-item>{{text}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
        <el-row :gutter="20">
  <el-col :span="18">
      <div class="video_left">
          <video
            ref="video"
            class="video_player"
            :src="video_url"
            controls="controls"
            controlslist="nodownload"
          >您的浏览器不支持 video 标签。</video>
          <div class="video_content" v-if="curriculumInfo.main_content">
            <mavon-editor
              v-model="curriculumInfo.main_content"
              defaultOpen="preview"
              :boxShadow="false"
              :editable="false"
              :subfield="false"
              :toolbarsFlag="false"
            ></mavon-editor>
          </div>
        </div>
  </el-col>
  <el-col :span="6">
      <div class="video_right">
          <dl class="choose-dl" v-for="(value, preindex) in selectArr" :key="value.id">
            <dt class="choose-dt">{{ value.title }}</dt>
            <dd class="choose-dd">
              <div
                class="choose-item"
                @click="selectActive(preindex, index, item)"
                :class="isactive === item.id ? 'addclass' : ''"
                v-for="(item, index) in value.videoInfoArr"
                :key="item.id"
              >
                <div class="curriculum">
                  <i
                    :class="isactive === item.id ? 'el-icon-video-camera-solid' : 'el-icon-video-camera'"
                  ></i>
                  {{ item.title }}
                </div>
                <div class="time">( {{ item.duration }} )</div>
              </div>
            </dd>
          </dl>
        </div>
  </el-col>
</el-row>
        <!-- <div class="video_left">
          <video
            ref="video"
            class="video_player"
            :src="video_url"
            controls="controls"
            controlslist="nodownload"
          >您的浏览器不支持 video 标签。</video>
          <div class="video_content" v-if="curriculumInfo.main_content">
            <mavon-editor
              v-model="curriculumInfo.main_content"
              defaultOpen="preview"
              :boxShadow="false"
              :editable="false"
              :subfield="false"
              :toolbarsFlag="false"
            ></mavon-editor>
          </div>
        </div> -->
        <!-- <div class="video_right">
          <dl class="choose-dl" v-for="(value, preindex) in selectArr" :key="value.id">
            <dt class="choose-dt">{{ value.title }}</dt>
            <dd class="choose-dd">
              <div
                class="choose-item"
                @click="selectActive(preindex, index, item)"
                :class="isactive === item.id ? 'addclass' : ''"
                v-for="(item, index) in value.videoInfoArr"
                :key="item.id"
              >
                <div class="curriculum">
                  <i
                    :class="isactive === item.id ? 'el-icon-video-camera-solid' : 'el-icon-video-camera'"
                  ></i>
                  {{ item.title }}
                </div>
                <div class="time">( {{ item.duration }} )</div>
              </div>
            </dd>
          </dl>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getTchTrainInfo } from "@/api/teachingResearchTraining.js";

export default {
  data() {
    return {
      text: "",
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        htmlcode: true, // 展示html源码
        help: true, // 帮助
        /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        save: true, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true // 预览
      },

      curriculumInfo: {
        main_content: ""
      },
      isactive: 0,
      tch_training_id: "",
      selectArr: [],
      video_url: ""
    };
  },
  created() {
    console.log(this.$route.query.id);
    this.tch_training_id = this.$route.query.id;
    this.text = this.$route.query.title;
  },
  mounted() {
    this.getTchTrainInfo();
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },

    //详情
    getTchTrainInfo() {
      getTchTrainInfo({
        tch_training_id: this.tch_training_id
      }).then(res => {
        this.selectArr = res.tchTrainingInfo.chapterInfoArr;
        this.curriculumInfo = res.tchTrainingInfo;
        console.log(this.selectArr[0].videoInfoArr[0], 444);
        this.isactive = this.selectArr[0].videoInfoArr[0].id;
        this.video_url = this.selectArr[0].videoInfoArr[0].video_url;
        // res.tchTrainingInfo.chapterInfoArr.map(item => {
        //   console.log(item);
        //   // console.log(item[Object.keys(item)[0]], 456);
        //   // console.log(item.videoInfoArr[0].video_url, 4444);
        //   // this.video_url = item.videoInfoArr[0].video_url;
        //   // console.log(item.videoInfoArr[0][1], 444444444444);
        //   // this.isactive = item.videoInfoArr[0].id;
        // });
      });
    },

    selectActive(preindex, index, item) {
      this.video_url = item.video_url;
      console.log(item, 134);
      this.isactive = item.id;
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  min-height: 100vh;
  padding: 10px;
  box-sizing: border-box;
}

.title {
  width: 100%;
  background-color: #fff;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  cursor: pointer;
}
.title_left {
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  margin-left: 10px;
}
.mainContent {
  width: 100%;
  // padding: 20px;
  // padding-top: 0;
  box-sizing: border-box;
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;

}
.main {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.video_right {
  height: 647px;
  background: #fff;
  color: #1b191b;
  padding: 20px;
  box-sizing: border-box;
}
.video_left {
}
.video_left {
  .video_player {
    width: 100%;
    border: 2px solid #dee2e9;
    object-fit: fill;
    margin-top: 20px;
  }
}
// .video_player {
//   width: 100%;
//   height: 453px;
// }
.video_content {
  width: 100%;
  height: auto;
  margin-top: 32px;

  box-sizing: border-box;
}
// .video_player {
//   width: 100%;
//   height: 100%;
//   position: absolute;
// }
// .video_content {
//   width: 100%;
//   padding-bottom: 56.25%;
//   height: 0;
//   position: relative;
//   margin-top: 20px;
// }

/deep/ .el-tree-node__content:hover {
  background: #000;
}
/deep/ .el-menu-item.is-active {
  background-color: #000 !important;
}
/deep/ .el-tree-node:focus > .el-tree-node__content {
  background-color: blue;
}
.addclass {
  font-weight: 700;
  color: #477fd2;
}
.choose-item {
  overflow: hidden;
  width: 100%;
  cursor: pointer;
}
.curriculum {
  float: left;
}
.time {
  float: right;
}
.choose-dt {
  font-size: 16px;
  font-weight: bold;
}
.choose-item {
  padding: 5px 0px;
}
// /deep/ .el-breadcrumb {
//   line-height: 20px;
//   padding-left: 20px;
// }
// /deep/ .el-icon-caret-right:before{
//     display: none;
// }
</style>

